import { Loader } from '../../../constants/actionTypes';

export const showLoader = () => {
    return  { type:Loader.SHOW_LOADER};
}

export const hideLoader = () => {
    return  { type:Loader.HIDE_LOADER};
}
